'use strict';

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.set");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.fill");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = undefined;

var _dec, _class2, _class3, _temp3;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactKonva = require('react-konva');

var _chromaJs = require('chroma-js');

var _chromaJs2 = _interopRequireDefault(_chromaJs);

var _shared = require('./shared');

var _Toolbar = require('../components/Toolbar');

var _LabelList = require('../components/LabelList');

var _LabelList2 = _interopRequireDefault(_LabelList);

var _LabelDropdown = require('../components/LabelDropdown');

var _LabelDropdown2 = _interopRequireDefault(_LabelDropdown);

var _util = require('../util');

var _constants = require('../constants');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var TOKEN_FONT_SIZE = 16;
var MAX_CANVAS_WIDTH = 2000;

function getCurve(p) {
  var factorX = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.2;
  var factorY = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.01;
  var maxY = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var _ref = [Math.max(p[0], p[2]), Math.min(p[0], p[2])],
      x1 = _ref[0],
      x2 = _ref[1];
  var _ref2 = [Math.max(p[1], p[3]), Math.min(p[1], p[3])],
      y1 = _ref2[0],
      y2 = _ref2[1];
  var dx = (x1 - x2) / 2;
  var dy = (y1 - y2) / 2;
  return [x2 + dx - dx * factorX, Math.max(y2 + dy - dx * factorY, maxY)];
}

function getRelKey(_ref3) {
  var head = _ref3.head,
      child = _ref3.child,
      label = _ref3.label;
  return head + '|' + child + '|' + label;
}

function getArrowColor(color) {
  return (0, _chromaJs2["default"])(color).darken(1.3).saturate(1.5).hex();
}

function getColorStops(colors) {
  var colorStops = [];

  for (var i = 0; i < colors.length; i++) {
    var color = colors[i];
    colorStops.push(i / colors.length, color, (i + 1) / colors.length, color);
  }

  if (colors.length > 1) {
    colorStops.push(1.0, colors[colors.length - 1]);
  }

  return colorStops;
}

function toggleElement(group, name, show) {
  var el = group.findOne(function (node) {
    return node.name() === name;
  });

  if (el) {
    if (show) el.show();else el.hide();
  }
}

function animate(func) {
  return function () {
    return requestAnimationFrame(func);
  };
}

var styles = function styles(theme) {
  return {
    stage: {},
    wrapper: {
      width: '100%',
      height: '100%',
      position: 'relative',
      overflow: 'auto'
    },
    checkboxWrapper: {
      alignSelf: 'center',
      display: 'flex',
      alignItems: 'center'
    },
    shortcuts: {
      display: 'block',
      width: '100%',
      outline: 0
    },
    heading: {
      display: 'flex',
      textAlign: 'left'
    }
  };
};

var Arc = function Arc(props) {
  var rel = props.rel,
      hideRelationArrow = props.hideRelationArrow,
      arrowWidth = props.arrowWidth,
      theme = props.theme;
  var _rel$color = rel.color,
      color = _rel$color === undefined ? theme.colorText : _rel$color,
      points = rel.points,
      tension = rel.tension;
  var arrowColor = getArrowColor(color);
  var pointerSize = hideRelationArrow ? 0 : arrowWidth * 2;
  return _react2["default"].createElement(_reactKonva.Arrow, {
    points: points,
    stroke: arrowColor,
    hitStrokeWidth: 0,
    strokeWidth: arrowWidth,
    pointerLength: pointerSize,
    pointerWidth: pointerSize,
    tension: tension,
    perfectDrawEnabled: false,
    listening: false
  });
};

var ArrowLabel = function ArrowLabel(props) {
  var rel = props.rel,
      i = props.i,
      handleDelete = props.handleDelete,
      labelHeight = props.labelHeight,
      drawing = props.drawing,
      onHover = props.onHover,
      listening = props.listening,
      isSpans = props.isSpans,
      labelFontSize = props.labelFontSize,
      theme = props.theme,
      spacing = props.spacing;
  var head = rel.head,
      child = rel.child,
      label = rel.label,
      _rel$color2 = rel.color,
      color = _rel$color2 === undefined ? theme.colorText : _rel$color2,
      labelX = rel.labelX,
      labelY = rel.labelY,
      rotation = rel.rotation,
      offsetX = rel.offsetX,
      offsetY = rel.offsetY,
      labelWidth = rel.labelWidth;
  var arrowColor = getArrowColor(color);

  var _onMouseOver = function _onMouseOver(event) {
    if (drawing) return;
    var parent = event.target.parent;
    if (!isSpans) toggleElement(parent, 'delete', true);
    parent.getLayer().batchDraw();
    onHover(i);
  };

  var _onMouseOut = function _onMouseOut(event) {
    if (drawing) return;
    var parent = event.target.parent;
    if (!isSpans) toggleElement(parent, 'delete', false);
    parent.getLayer().batchDraw();
    onHover(null);
  };

  return _react2["default"].createElement(_reactKonva.Label, {
    x: labelX,
    y: labelY,
    rotation: rotation,
    offsetX: offsetX,
    offsetY: offsetY,
    key: i,
    onClick: handleDelete(head, child, label),
    onTouchStart: handleDelete(head, child, label),
    onMouseOver: function onMouseOver(e) {
      return animate(_onMouseOver(e));
    },
    onMouseOut: function onMouseOut(e) {
      return animate(_onMouseOut(e));
    },
    listening: listening,
    perfectDrawEnabled: false
  }, _react2["default"].createElement(_reactKonva.Tag, {
    fill: arrowColor,
    cornerRadius: 5,
    listening: listening,
    perfectDrawEnabled: false
  }), _react2["default"].createElement(_reactKonva.Text, {
    fill: 'white',
    fontSize: labelFontSize,
    fontFamily: theme.fontSecondary,
    fontStyle: 'bold',
    text: label,
    padding: spacing / 5,
    height: labelHeight,
    width: labelWidth,
    verticalAlign: 'middle',
    transformsEnabled: 'none',
    listening: listening,
    perfectDrawEnabled: false
  }), _react2["default"].createElement(_reactKonva.Text, {
    fill: arrowColor,
    text: '\xD7',
    fontStyle: 'bold',
    fontSize: labelFontSize,
    fontFamily: theme.fontSecondary,
    verticalAlign: 'middle',
    x: labelWidth,
    y: -5,
    transformsEnabled: 'position',
    listening: listening,
    name: 'delete',
    visible: false,
    perfectDrawEnabled: false
  }));
};

var Token = function (_React$Component) {
  _inherits(Token, _React$Component);

  function Token() {
    var _ref4;

    var _temp, _this, _ret;

    _classCallCheck(this, Token);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref4 = Token.__proto__ || Object.getPrototypeOf(Token)).call.apply(_ref4, [this].concat(args))), _this), _this.getHasRel = function () {
      var _this$props = _this.props,
          token = _this$props.token,
          relColors = _this$props.relColors;
      return !![].concat(_toConsumableArray(relColors[token.id] || [])).length;
    }, _this.getIsDrawingSelected = function () {
      var _this$props2 = _this.props,
          drawing = _this$props2.drawing,
          drawingRange = _this$props2.drawingRange,
          token = _this$props2.token;
      return drawing && drawingRange && drawingRange.includes(token.id);
    }, _this.getFill = function () {
      var _this$props3 = _this.props,
          isSelected = _this$props3.isSelected,
          theme = _this$props3.theme;

      var hasRel = _this.getHasRel();

      return isSelected ? theme.bgCardTertiary : hasRel ? null : theme.bgCard;
    }, _this.getHoverFill = function () {
      var _this$props4 = _this.props,
          selected = _this$props4.selected,
          theme = _this$props4.theme,
          token = _this$props4.token;
      var hasSelected = selected !== null && selected !== token.id;
      return hasSelected ? theme.bgCardSecondary : null;
    }, _this.getStroke = function () {
      var _this$props5 = _this.props,
          drawingValid = _this$props5.drawingValid,
          theme = _this$props5.theme,
          isSelected = _this$props5.isSelected,
          token = _this$props5.token;
      var drawingColor = drawingValid ? theme.accept : theme.reject;

      var hasRel = _this.getHasRel();

      var isDrawingSelected = _this.getIsDrawingSelected();

      return isDrawingSelected ? drawingColor : isSelected ? theme.bgCardTertiary : hasRel || token.disabled ? theme.bgCard : token.label ? theme.bgCardQuaternary : theme.bgCardTertiary;
    }, _this.getHoverStroke = function () {
      var _this$props6 = _this.props,
          drawingValid = _this$props6.drawingValid,
          drawingRange = _this$props6.drawingRange,
          drawing = _this$props6.drawing,
          token = _this$props6.token,
          label = _this$props6.label,
          theme = _this$props6.theme,
          getColor = _this$props6.getColor,
          isSpans = _this$props6.isSpans;
      var isDrawingSelected = drawing && drawingRange && drawingRange.includes(token.id);
      var drawingColor = drawingValid ? theme.accept : theme.reject;
      return isDrawingSelected ? drawingColor : isSpans ? theme.bgCardQuaternary : getArrowColor(getColor(label));
    }, _this.getGradient = function () {
      var _this$props7 = _this.props,
          isSelected = _this$props7.isSelected,
          relColors = _this$props7.relColors,
          token = _this$props7.token;
      var colors = [].concat(_toConsumableArray(relColors[token.id] || []));
      var colorStops = getColorStops(colors);

      var hasRel = _this.getHasRel();

      var grad = {
        fillLinearGradientStartPoint: {
          x: 0,
          y: 0
        },
        fillLinearGradientEndPoint: {
          x: token.width,
          y: token.height
        },
        fillLinearGradientColorStops: colorStops
      };
      return !isSelected && hasRel ? grad : {};
    }, _this.getTextGradient = function () {
      var _this$props8 = _this.props,
          isSelected = _this$props8.isSelected,
          theme = _this$props8.theme,
          token = _this$props8.token,
          relColors = _this$props8.relColors;
      var colors = [].concat(_toConsumableArray(relColors[token.id] || []));
      var colorStops = getColorStops(colors);
      var textColorFade = isSelected ? theme.bgCardTertiary : colorStops.length ? colorStops[colorStops.length - 1] : theme.bgCard;
      var grad = {
        fillLinearGradientStartPoint: {
          x: 0,
          y: 0
        },
        fillLinearGradientEndPoint: {
          x: token.width,
          y: 0
        },
        fillLinearGradientColorStops: [0.8, theme.colorText, 0.99, textColorFade],
        ellipsis: true,
        wrap: 'none'
      };
      return token.ellipsis ? grad : {};
    }, _this.getDash = function () {
      var token = _this.props.token;
      return !!token.label ? [2, 2] : null;
    }, _this.handleClick = function (fn) {
      var _this$props9 = _this.props,
          token = _this$props9.token,
          isManual = _this$props9.isManual;
      return !token.disabled && isManual ? function (e) {
        return animate(fn(e));
      } : null;
    }, _this.onMouseOver = function (event) {
      var _this$props10 = _this.props,
          drawing = _this$props10.drawing,
          onHover = _this$props10.onHover,
          token = _this$props10.token,
          showLabels = _this$props10.showLabels;
      if (drawing) return;
      var parent = event.target.parent;
      var el = parent.children[0];
      var group = parent.parent;

      var fill = _this.getHoverFill();

      var stroke = _this.getHoverStroke();

      if (fill) el.fill(fill);
      if (stroke) el.stroke(stroke);
      if (token.label) el.dashEnabled(false);
      if (!showLabels) toggleElement(group, 'label', true);
      el.getLayer().batchDraw();
      onHover(parent.id());
    }, _this.onMouseOut = function (event) {
      var _this$props11 = _this.props,
          drawing = _this$props11.drawing,
          isSpans = _this$props11.isSpans,
          isSelected = _this$props11.isSelected,
          showLabels = _this$props11.showLabels,
          onHover = _this$props11.onHover;
      if (drawing) return;
      var parent = event.target.parent;
      var el = parent.children[0];
      var group = parent.parent;
      if (!isSpans || isSpans && !isSelected) el.fill(_this.getFill());
      el.stroke(_this.getStroke());
      el.dashEnabled(true);
      el.dash(_this.getDash());
      if (!showLabels) toggleElement(group, 'label', false);
      el.getLayer().batchDraw();
      onHover(null);
    }, _this.onClick = function (event) {
      var _this$props12 = _this.props,
          theme = _this$props12.theme,
          isSelected = _this$props12.isSelected,
          handleTokenClick = _this$props12.handleTokenClick;
      var parent = event.target.parent;
      var el = parent.children[0];

      if (!isSelected) {
        el.fill(theme.bgCardTertiary);
        el.stroke(theme.bgCardTertiary);
        el.dashEnabled(false);
      } else {
        el.fill(_this.getFill());
        el.stroke(_this.getStroke());
        el.dashEnabled(true);
        el.dash(_this.getDash());
      }

      el.getLayer().batchDraw();
      handleTokenClick(event);

      _this.onMouseOut(event); // touch devices

    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Token, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prev) {
      var showLabels = this.props.showLabels;

      if (this.ref && prev.showLabels !== showLabels) {
        toggleElement(this.ref.parent, 'label', showLabels);
        this.ref.getLayer().batchDraw();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          token = _props.token,
          theme = _props.theme,
          drawing = _props.drawing,
          tokenFontSize = _props.tokenFontSize,
          labelHeight = _props.labelHeight,
          spacing = _props.spacing,
          handleTokenDblclick = _props.handleTokenDblclick,
          labelFontSize = _props.labelFontSize,
          isSpans = _props.isSpans,
          showLabels = _props.showLabels,
          drawingHandlers = _props.drawingHandlers;
      var text = token.text,
          x = token.x,
          y = token.y,
          width = token.width,
          height = token.height,
          id = token.id,
          disabled = token.disabled,
          tokenLabel = token.label,
          labelWidth = token.labelWidth,
          ellipsis = token.ellipsis;
      var labelX = x + width / 2 - labelWidth / 2;
      var labelY = y + labelHeight + spacing;
      var listenHover = !disabled || !isSpans;
      var fill = this.getFill();
      var stroke = this.getStroke();
      var grad = this.getGradient();
      var textGrad = this.getTextGradient();
      var dash = this.getDash();
      var wrapLabel = tokenLabel && labelWidth > width;
      return _react2["default"].createElement(_reactKonva.Group, drawingHandlers, _react2["default"].createElement(_reactKonva.Label, {
        x: x,
        y: y,
        width: width,
        height: height,
        transformsEnabled: 'position',
        onClick: this.handleClick(this.onClick),
        onTouchStart: this.handleClick(this.onClick),
        onDblclick: this.handleClick(handleTokenDblclick),
        onDbltap: this.handleClick(handleTokenDblclick),
        onMouseOver: listenHover ? function (e) {
          return animate(_this2.onMouseOver(e));
        } : null,
        onMouseOut: listenHover ? function (e) {
          return animate(_this2.onMouseOut(e));
        } : null,
        opacity: disabled ? 0.5 : 1.0,
        perfectDrawEnabled: false,
        name: 'token',
        id: id,
        ref: function ref(x) {
          _this2.ref = x;
        },
        listening: !!drawing || !disabled
      }, _react2["default"].createElement(_reactKonva.Tag, _extends({
        stroke: stroke,
        hitStrokeWidth: 0,
        strokeWidth: 2,
        fill: fill,
        cornerRadius: 5,
        dash: dash,
        perfectDrawEnabled: false,
        transformsEnabled: 'position',
        fillPriority: 'linear-gradient'
      }, grad)), _react2["default"].createElement(_reactKonva.Text, _extends({
        fill: ellipsis ? null : theme.colorText,
        fontSize: tokenFontSize,
        fontFamily: theme.fontPrimary,
        fontStyle: 'bold',
        text: text,
        padding: spacing,
        width: width,
        height: height,
        verticalAlign: 'middle',
        perfectDrawEnabled: false,
        listening: !isSpans,
        transformsEnabled: 'position',
        name: 'token-text'
      }, textGrad))), !!tokenLabel && !disabled && _react2["default"].createElement(_reactKonva.Label, {
        x: Math.max(labelX, 0),
        y: labelY,
        key: id,
        listening: false,
        name: 'label',
        transformsEnabled: 'position',
        perfectDrawEnabled: false,
        visible: showLabels
      }, _react2["default"].createElement(_reactKonva.Tag, {
        fill: theme.colorText,
        stroke: theme.bgCard,
        hitStrokeWidth: 0,
        strokeWidth: 2,
        cornerRadius: 5,
        transformsEnabled: 'position',
        perfectDrawEnabled: false
      }), _react2["default"].createElement(_reactKonva.Text, {
        fill: theme.bgCard,
        text: tokenLabel,
        fontStyle: 'bold',
        fontSize: labelFontSize,
        fontFamily: theme.fontSecondary,
        verticalAlign: 'middle',
        height: labelHeight,
        padding: spacing / 5,
        width: Math.min(labelWidth, width),
        transformsEnabled: 'position',
        perfectDrawEnabled: false,
        ellipsis: wrapLabel,
        wrap: 'none'
      })));
    }
  }]);

  return Token;
}(_react2["default"].Component);

var Relations = (_dec = (0, _util.withStyles)(styles, {
  withTheme: true
}), _dec(_class2 = (_temp3 = _class3 = function (_React$Component2) {
  _inherits(Relations, _React$Component2);

  function Relations() {
    var _ref5;

    var _temp2, _this3, _ret2;

    _classCallCheck(this, Relations);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref5 = Relations.__proto__ || Object.getPrototypeOf(Relations)).call.apply(_ref5, [this].concat(args))), _this3), _this3.keymap = 'RELATIONS', _this3.layers = {}, _this3.measureCanvases = {}, _this3.state = {
      width: 500,
      selected: null,
      hover: null,
      arcHover: null,
      rows: [],
      relations: [],
      origRelations: [],
      visibleRelations: [],
      relColors: {},
      spans: [],
      origSpans: [],
      label: '',
      spanLabel: '',
      showAll: true,
      showLabels: false,
      wrap: true,
      drawing: null,
      drawingValid: null,
      drawingRange: null,
      x: null,
      y: null,
      mode: 'rels',
      modes: [],
      hasSpans: false,
      toMerge: null,
      selectKey: false
    }, _this3.componentWillMount = function () {
      var _this3$props$config = _this3.props.config,
          wrapRelations = _this3$props$config.wrapRelations,
          showRelationsLabels = _this3$props$config.showRelationsLabels,
          relationsSpanLabels = _this3$props$config.relationsSpanLabels;

      _this3.setState({
        wrap: wrapRelations,
        showLabels: showRelationsLabels
      });

      if (relationsSpanLabels && relationsSpanLabels.length) {
        _this3.setState({
          modes: ['rels', 'spans'],
          hasSpans: true
        });
      }
    }, _this3.componentDidMount = function () {
      var config = _this3.props.config;

      _this3.setupData(_this3.props);

      if (config.labels && config.labels.length) {
        _this3.setState({
          label: config.labels[0]
        });
      }

      if (config.relationsSpanLabels && config.relationsSpanLabels.length) {
        _this3.setState({
          spanLabel: config.relationsSpanLabels[0]
        });
      }

      if (_this3.content) {
        _this3.content.addEventListener('scroll', _this3.repositionStage);

        _this3.repositionStage();
      }

      if (_this3.context.shortcuts) {
        var selectKey = (0, _util.getKeyName)(_this3.context, _this3.keymap, 'select').toLowerCase();
        document.body.addEventListener('keydown', function (event) {
          if (event.key.toLowerCase() === selectKey) _this3.setState({
            selectKey: true
          });
        });
        document.body.addEventListener('keyup', function (event) {
          if (event.key.toLowerCase() === selectKey) {
            _this3.setState({
              selectKey: false
            });

            if (_this3.state.toMerge) {
              _this3.setState({
                toMerge: null,
                selected: null
              });
            }
          }
        });
      }
    }, _this3.componentDidUpdate = function (prev) {
      var content = _this3.props.content;

      if (prev.content && prev.content[_constants.TASK_ID] != content[_constants.TASK_ID]) {
        _this3.setupData(_this3.props);

        return;
      }
    }, _this3.getMeasureCanvas = function () {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'token';
      if (_this3.measureCanvases[type]) return _this3.measureCanvases[type]; // Create a canvas so we can measure text

      var _this3$props = _this3.props,
          labelFontSize = _this3$props.labelFontSize,
          tokenFontSize = _this3$props.tokenFontSize,
          theme = _this3$props.theme;
      var measureCanvas = document.createElement('canvas');
      var ctx = measureCanvas.getContext('2d');

      if (type === 'token') {
        ctx.font = 'bold ' + tokenFontSize + 'px ' + theme.fontPrimary;
      } else if (type === 'label') {
        ctx.font = 'bold ' + labelFontSize + 'px ' + theme.fontSecondary;
      }

      _this3.measureCanvases[type] = ctx;
      return ctx;
    }, _this3.measureTextWidth = function (type, textContent) {
      var _this3$props2 = _this3.props,
          labelFontSize = _this3$props2.labelFontSize,
          tokenFontSize = _this3$props2.tokenFontSize;
      var text = textContent || '';

      var ctx = _this3.getMeasureCanvas(type);

      var width = ctx.measureText(text).width; // If width is falsy and canvas measuring fails for whatever reason,
      // use an approximate fallback

      if (!width && type === 'token') return tokenFontSize * text.length * 0.6;
      if (!width && type === 'label') return labelFontSize * text.length * 0.55;
      return width;
    }, _this3.getCardWidth = function () {
      var padding = _this3.props.theme.cardPadding || 0;
      return _this3.content ? _this3.content.clientWidth - padding * 2 : 500;
    }, _this3.repositionStage = function () {
      var _this3$state = _this3.state,
          wrap = _this3$state.wrap,
          offset = _this3$state.offset; // https://konvajs.org/docs/sandbox/Canvas_Scrolling.html

      if (_this3.content && !wrap && offset >= MAX_CANVAS_WIDTH) {
        var dx = _this3.content.scrollLeft;

        var stage = _this3.layers.tokens.getStage();

        if (dx <= offset - _this3.getCardWidth() * 2) {
          stage.container().style.transform = 'translateX(' + dx + 'px)';
          stage.x(-dx);
          stage.batchDraw();
        }
      }
    }, _this3.resetStage = function () {
      var stage = _this3.layers.tokens.getStage();

      stage.container().style.transform = 'translateX(0px)';
      stage.x(0);
      stage.batchDraw();
    }, _this3.setupData = function (props) {
      var showAll = _this3.state.showAll;
      var spans = props.content.spans || [];
      var prevRels = props.content.relations || [];
      var rels = prevRels.map(function (r) {
        return _extends({}, r, {
          color: r.color || _this3.getColor(r.label)
        });
      });

      var tokens = _this3.formatTokens(props, spans, rels, _this3.state.wrap);

      var rows = tokens.rows,
          tokensById = tokens.tokensById,
          height = tokens.height,
          width = tokens.width,
          padding = tokens.padding,
          ctxLabel = tokens.ctxLabel,
          offset = tokens.offset; // Make sure all relations have the right format with head_span and child_span

      var relations = tokens.relations.map(function (rel) {
        var updated = _this3.getRelation(rel.head, rel.child, rel.label, tokensById);

        return _extends({}, updated, {
          color: rel.color || updated.color
        });
      });

      _this3.setState({
        rows: rows,
        tokensById: tokensById,
        height: height,
        width: width,
        padding: padding,
        relations: relations,
        spans: spans,
        origRelations: relations,
        origSpans: spans,
        ctxLabel: ctxLabel,
        offset: offset
      }, function () {
        return _this3.updateVisibleRelations(relations, showAll);
      }); // Make sure task always has "spans" and "relations"


      _this3.props.update({
        spans: spans,
        relations: relations
      });
    }, _this3.updateVisibleRelations = function (relations) {
      var showAll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var filteredRels = _this3.filterRelations(relations, showAll);

      var relColors = _this3.getRelationColors(relations);

      var visibleRelations = _this3.getArcs(filteredRels);

      _this3.setState({
        visibleRelations: visibleRelations,
        relColors: relColors
      });
    }, _this3.updateTokens = function (wrap) {
      var tokens = _this3.formatTokens(_this3.props, _this3.state.spans, _this3.state.relations, wrap);

      var rows = tokens.rows,
          tokensById = tokens.tokensById,
          height = tokens.height,
          width = tokens.width,
          padding = tokens.padding,
          relations = tokens.relations,
          offset = tokens.offset;

      _this3.setState({
        rows: rows,
        tokensById: tokensById,
        height: height,
        width: width,
        padding: padding,
        offset: offset
      }, function () {
        _this3.updateRelations(relations);
      });
    }, _this3.updateSpans = function (spans) {
      _this3.setState({
        spans: spans
      }, function () {
        return _this3.updateTokens(_this3.state.wrap);
      });

      _this3.props.update({
        spans: spans
      });
    }, _this3.updateSpan = function (tokenId, updates) {
      // Update an existing span
      var spans = _this3.state.spans;
      var index = spans.map(function (s) {
        return s.token_end;
      }).indexOf(tokenId);
      var current = spans.find(function (s) {
        return s.token_end == tokenId;
      });
      var prevSpans = spans.filter(function (s) {
        return s.token_end !== tokenId;
      });

      var newSpan = _extends({}, current, updates); // Insert new span at its old position so index for color etc. matches


      var newSpans = (0, _util.insertInto)(prevSpans, newSpan, index);

      _this3.updateSpans(newSpans);
    }, _this3.updateRelations = function (relations) {
      _this3.setState({
        relations: relations,
        selected: null,
        hover: null,
        arcHover: null
      }, function () {
        _this3.updateVisibleRelations(relations, _this3.state.showAll);
      });

      _this3.props.update({
        relations: relations
      });
    }, _this3.handleReset = function () {
      var _this3$state2 = _this3.state,
          origRelations = _this3$state2.origRelations,
          origSpans = _this3$state2.origSpans;

      _this3.setState({
        relations: origRelations,
        spans: origSpans,
        selected: null
      }, function () {
        _this3.updateTokens(_this3.state.wrap);
      });

      _this3.props.update({
        spans: origSpans,
        relations: origRelations
      });
    }, _this3.mergeTokens = function (content, spans) {
      var _content$tokens = content.tokens,
          tokens = _content$tokens === undefined ? [] : _content$tokens,
          text = content.text;
      var spansByEnd = Object.assign.apply(Object, [{}].concat(_toConsumableArray(spans.map(function (span) {
        return _defineProperty({}, span.token_end, span);
      })))); // Not token_end + 1 here because there's no need to account for token that has span

      var spansBySkip = new Set([].concat(_toConsumableArray((0, _util.flattenArray)(spans.map(function (span) {
        return (0, _util.range)(span.token_start, span.token_end);
      }))))); // Ensure that there's a record of previous tokens

      var skippedById = {}; // Also keep a record of replaced tokens so we can adjust relations

      var replacedById = {};
      var result = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = tokens[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var token = _step.value;
          var span = spansByEnd[token.id];

          if (span) {
            // Token is the start of a span, create merged token
            // Spread text to prevent off-by-one errors caused by emoji
            var newText = [].concat(_toConsumableArray(text)).slice(span.start, span.end).join('');

            var newToken = _extends({}, token, span, {
              text: newText,
              merged: true
            });

            result.push(newToken);
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = (0, _util.range)(span.token_start, span.token_end)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var replaced = _step2.value;
                replacedById[replaced] = newToken.id;
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2["return"]) {
                  _iterator2["return"]();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          } else if (!spansBySkip.has(token.id)) {
            result.push(token);
          } else {
            skippedById[token.id] = token;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"]) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return {
        tokens: result,
        tokensById: skippedById,
        replacedById: replacedById
      };
    }, _this3.formatTokens = function (props, spans, relations, wrap) {
      var spacing = props.spacing,
          content = props.content,
          tokenHeight = props.tokenHeight,
          theme = props.theme;
      var hasSpans = _this3.state.hasSpans;
      var height = tokenHeight;

      var _this3$mergeTokens = _this3.mergeTokens(content, spans),
          tokens = _this3$mergeTokens.tokens,
          tokensById = _this3$mergeTokens.tokensById,
          replacedById = _this3$mergeTokens.replacedById;

      var maxWidth = _this3.getCardWidth();

      var padding = wrap ? theme.relationHeightWrap : theme.relationHeight;
      var spacer = spacing * 0.75;
      var rows = [[]];
      var offset = 1;
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = tokens[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var token = _step3.value;
          var origWidth = _this3.measureTextWidth('token', token.text) + spacing * 2;
          var width = wrap ? Math.min(origWidth, maxWidth - spacing) : origWidth;

          if (wrap && offset + width + 1 > maxWidth) {
            rows.push([]);
            offset = 1;
          }

          var rowIdx = rows.length - 1;
          var y = rowIdx === 0 ? padding : padding * 2 * (rowIdx + 1) - padding;
          var labelWidth = _this3.measureTextWidth('label', token.label) + 2 * spacing / 4;
          var ellipsis = wrap ? origWidth > width : origWidth > maxWidth;

          var newToken = _extends({}, token, {
            x: offset,
            y: y,
            width: !ellipsis || wrap ? width : maxWidth,
            height: height,
            row: rowIdx,
            rowIdx: rows[rowIdx].length,
            ellipsis: ellipsis,
            labelWidth: labelWidth
          });

          tokensById[token.id] = newToken;
          rows[rowIdx].push(newToken);
          offset += width + (token.ws ? spacer * 2 : spacer / 2);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3["return"]) {
            _iterator3["return"]();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var fullHeight = rows[rows.length - 1][0].y + height + (hasSpans ? spacer * 5 : spacer * 2);
      var fullWidth = wrap ? maxWidth : offset < MAX_CANVAS_WIDTH ? offset + spacer * 2 : maxWidth * 2.5; // Recalculate relations if tokens were merged or unmerged

      var newRelations = !Object.keys(replacedById).length ? relations : relations.map(function (rel) {
        var newHead = replacedById[rel.head];
        var newChild = replacedById[rel.child];
        var head = typeof newHead !== 'undefined' ? newHead : rel.head;
        var child = typeof newChild !== 'undefined' ? newChild : rel.child;

        var newRel = _this3.getRelation(head, child, rel.label, tokensById);

        return _extends({}, rel, newRel);
      });
      return {
        rows: rows,
        tokensById: tokensById,
        height: fullHeight,
        width: fullWidth,
        offset: offset,
        padding: padding,
        relations: newRelations
      };
    }, _this3.getColor = function (label) {
      var _this3$props$config2 = _this3.props.config,
          labels = _this3$props$config2.labels,
          labelColors = _this3$props$config2.labelColors;

      if (labelColors[label]) {
        return labelColors[label];
      }

      var index = labels.indexOf(label);
      var i = index !== -1 ? index : labels.length + 1;
      return (0, _util.getColor)(_constants.RELATION_COLORS, i);
    }, _this3.deleteSelected = function () {
      _this3.handleDeleteSpan(_this3.state.selected);
    }, _this3.handleDeleteSpan = function (tokenId) {
      var _this3$state3 = _this3.state,
          tokensById = _this3$state3.tokensById,
          mode = _this3$state3.mode;
      var token = tokensById[tokenId];

      if (mode === 'spans' && token) {
        // Token is a "special" span token, so remove it from the spans
        if (token.label) _this3.splitSpan(token);
        return;
      }
    }, _this3.toggleElementSelect = function (label) {
      var _this3$state4 = _this3.state,
          mode = _this3$state4.mode,
          selected = _this3$state4.selected;

      _this3.setState(mode === 'spans' ? {
        spanLabel: label
      } : {
        label: label
      });

      if (mode === 'spans' && selected !== null) {
        // Change the currently selected label if available
        _this3.updateSpan(selected, {
          label: label
        });
      }
    }, _this3.getRelationToken = function (token) {
      return {
        start: token.start,
        end: token.end,
        token_start: token.token_start || token.id,
        token_end: token.token_end || token.id,
        label: token.label || null
      };
    }, _this3.getRelation = function (headId, childId, label) {
      var tokensById = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var tokens = tokensById || _this3.state.tokensById;

      var color = _this3.getColor(label);

      var head = _this3.getRelationToken(tokens[headId]);

      var child = _this3.getRelationToken(tokens[childId]);

      return {
        head: headId,
        child: childId,
        head_span: head,
        child_span: child,
        color: color,
        label: label
      };
    }, _this3.handleTokenClick = function (token) {
      return function (event) {
        var _this3$state5 = _this3.state,
            selected = _this3$state5.selected,
            relations = _this3$state5.relations,
            label = _this3$state5.label,
            mode = _this3$state5.mode,
            selectKey = _this3$state5.selectKey,
            toMerge = _this3$state5.toMerge;

        if (selected === token.id) {
          // Currently selected token is clicked
          _this3.setState({
            selected: null
          });
        } else if (mode === 'spans') {
          if (token.label) {
            // Special token is clicked
            _this3.setState({
              selected: token.id,
              spanLabel: token.label
            });
          } else {
            // Clicked token is regular non-span token, add a span to it
            if (selectKey) {
              // Highlighting multiple by holding shift
              if (toMerge === null) {
                _this3.setState({
                  toMerge: token,
                  selected: token.id
                });
              } else {
                var _this4;

                var tokens = [token, toMerge].sort(function (a, b) {
                  return a.id - b.id;
                });

                (_this4 = _this3).addSpan.apply(_this4, _toConsumableArray(tokens));

                _this3.setState({
                  toMerge: null,
                  selected: null
                });
              }
            } else {
              _this3.addSpan(token, token);

              _this3.setState({
                selected: null
              });
            }
          }
        } else if (selected !== null) {
          // Another token is selected and different token is clicked
          // Add relation between current selection and new token
          var rel = _this3.getRelation(selected, token.id, label);

          _this3.updateRelations([].concat(_toConsumableArray(relations), [rel]));
        } else {
          // Select the token
          _this3.setState({
            selected: token.id
          });
        }
      };
    }, _this3.handleTokenDblclick = function (token) {
      return function () {
        var _this3$state6 = _this3.state,
            label = _this3$state6.label,
            mode = _this3$state6.mode,
            relations = _this3$state6.relations,
            selected = _this3$state6.selected;
        if (mode === 'spans' || selected !== null) return; // We're using the double-click to allow attaching a token to itself

        var rel = _this3.getRelation(token.id, token.id, label);

        _this3.updateRelations([].concat(_toConsumableArray(relations), [rel]));
      };
    }, _this3.handleDelete = function (head, child, label) {
      return function () {
        var relations = _this3.state.relations;
        var newRels = relations.filter(function (r) {
          return getRelKey(r) !== getRelKey({
            head: head,
            child: child,
            label: label
          });
        });

        _this3.updateRelations(newRels);
      };
    }, _this3.getRelationColors = function (relations) {
      var relColors = {};
      relations.forEach(function (_ref7) {
        var head = _ref7.head,
            child = _ref7.child,
            label = _ref7.label,
            color = _ref7.color;

        var c = color || _this3.getColor(label);

        if (!relColors[head]) relColors[head] = new Set();
        if (!relColors[child]) relColors[child] = new Set();
        relColors[head].add(c);
        relColors[child].add(c);
      });
      return relColors;
    }, _this3.getLevelsByRow = function (relations, tokensById) {
      var relLevels = {};
      relations.forEach(function (_ref8) {
        var head = _ref8.head,
            child = _ref8.child,
            label = _ref8.label; // Create levels by row to give all relations unique levels

        var row = tokensById[head].row;

        if (row === tokensById[child].row) {
          if (!relLevels[row]) relLevels[row] = [];
          relLevels[row].push({
            head: head,
            child: child,
            label: label
          });
        }
      });
      var levelsByRow = {};
      Object.keys(relLevels).forEach(function (key) {
        levelsByRow[key] = Object.assign.apply(Object, [{}].concat(_toConsumableArray([].concat(_toConsumableArray(relLevels[key])).sort(function (a, b) {
          return Math.abs(a.head - a.child) - Math.abs(b.head - b.child);
        }).map(function (rel, i) {
          return _defineProperty({}, getRelKey(rel), i);
        }))));
      });
      return levelsByRow;
    }, _this3.getArcs = function (rels) {
      var _this3$state7 = _this3.state,
          padding = _this3$state7.padding,
          tokensById = _this3$state7.tokensById;
      var _this3$props3 = _this3.props,
          spacing = _this3$props3.spacing,
          arrowWidth = _this3$props3.arrowWidth,
          labelHeight = _this3$props3.labelHeight,
          arcHeight = _this3$props3.arcHeight;

      var levelsByRow = _this3.getLevelsByRow(rels, tokensById);

      return rels.map(function (rel) {
        var head = rel.head,
            child = rel.child,
            label = rel.label;
        var ht = tokensById[head];
        var ct = tokensById[child];
        var spacer = arrowWidth / 2 - spacing / 2;
        var hx = ht.x + ht.width / 2 - spacer;
        var cx = ct.x + ct.width / 2 - spacer;
        var isUp = ht.y > ct.y;
        var isDown = ht.y <= ct.y;
        var isRight = ht.x <= ct.x;
        var isLeft = ht.x > ct.x;
        var isSameLine = ht.row === ct.row;
        var isSelf = head === child;
        var points = [hx, ht.y, cx, ct.y];
        var curve = [];
        var arrowSpacing = arrowWidth + labelHeight / 2;

        if (isDown) {
          points = [hx, ht.y + ht.height + arrowSpacing, cx, ct.y - arrowSpacing];
          curve = getCurve(points);
        }

        if (isUp) {
          points = [hx, ht.y - arrowSpacing, cx, ct.y + ct.height + arrowSpacing];
          curve = getCurve(points, isLeft ? 0.2 : -0.2, isLeft ? 0.01 : -0.01);
        }

        if (isSameLine) {
          var levels = levelsByRow[ht.row];
          var levelsLength = Object.keys(levels).length;
          var level = levels[getRelKey(rel)]; // Calculate points and offsets to avoid overlaps

          var offsetFactor = (levelsLength + 1) / (levelsLength - level);
          var htOffsetX = Math.max(ht.width / 2 / offsetFactor, arrowWidth);
          var ctOffsetX = Math.max(ct.width / 2 / offsetFactor, arrowWidth);

          if (isSelf) {
            points = [hx, ht.y - arrowWidth, cx, ct.y];
          } else {
            points = [isLeft ? ht.x + htOffsetX : ht.x + ht.width - htOffsetX, ht.y - arrowWidth, isLeft ? ct.x + ctOffsetX : ct.x + ct.width - ctOffsetX, ct.y - arrowWidth];
          }

          var levelPadding = padding + spacer * 3 - arrowWidth;
          var levelHeight = Math.min(levelsLength * arcHeight, levelPadding) / levelsLength;
          var offsetY = points[1] - levelHeight * (level + 1);
          curve = [points[0], offsetY, points[2], offsetY];
        }

        var labelWidth = _this3.measureTextWidth('label', label) + 2 * spacing / 5;
        var pts = [points[0], points[1]].concat(_toConsumableArray(curve), [points[2], points[3]]);
        var rad = Math.atan2(pts[3] - pts[1], pts[2] - pts[0]);
        var rotation = rad * (180 / Math.PI);
        return _extends({}, rel, {
          points: pts,
          labelX: isSameLine ? isLeft ? points[2] - (points[2] - points[0]) / 2 - labelWidth / 2 : points[0] + (points[2] - points[0]) / 2 - labelWidth / 2 : rotation ? pts[0] : pts[0] - labelWidth / 2,
          labelY: isSameLine ? curve[1] : rotation ? pts[1] : pts[1] - labelHeight / 2,
          rotation: isSameLine ? 0 : isLeft ? 180 + rotation : rotation,
          offsetX: isSameLine ? 0 : isRight || !rotation ? -spacing : labelWidth + spacing,
          offsetY: !rotation ? 0 : labelHeight / 2,
          labelWidth: labelWidth,
          tension: isSameLine ? 0 : 0.5
        });
      });
    }, _this3.filterRelations = function (relations, showAll) {
      var _this3$state8 = _this3.state,
          hover = _this3$state8.hover,
          selected = _this3$state8.selected;
      if (showAll) return relations;

      if (hover === null || selected !== null) {
        return [];
      }

      return relations.filter(function (_ref10) {
        var head = _ref10.head,
            child = _ref10.child;
        return head === hover || child === hover;
      });
    }, _this3.isValidSelection = function (spans, tokensById, startToken, endToken) {
      if (isNaN(startToken) || isNaN(endToken)) return false; // Check if any of the other spans contain overlap the new selection

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = spans[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var _ref11 = _step4.value;
          var token_start = _ref11.token_start,
              token_end = _ref11.token_end;

          if (Math.max(token_start, startToken) <= Math.min(token_end, endToken)) {
            return false;
          }
        } // Check if any tokens in the range are disabled

      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4["return"]) {
            _iterator4["return"]();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = (0, _util.range)(startToken, endToken + 1)[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var idx = _step5.value;
          var token = tokensById[idx];

          if (!token || token.disabled) {
            return false;
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5["return"]) {
            _iterator5["return"]();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      return true;
    }, _this3.getTokenSelection = function (drawing) {
      var _this3$state9 = _this3.state,
          tokensById = _this3$state9.tokensById,
          spans = _this3$state9.spans;
      if (!drawing || !drawing.height || !drawing.width) return null;
      var selected = new Set();

      _this3.layers.tokens.children.each(function (layerGroup) {
        var group = layerGroup.children[0];
        if (group.name() !== 'token') return;
        var rect = group.getClientRect();
        var x = drawing.x,
            y = drawing.y,
            width = drawing.width,
            height = drawing.height;

        if (rect.x === x && rect.y === y && rect.width === width && rect.height === height) {
          return;
        }

        if ((0, _util.checkIntersection)(rect, drawing)) {
          selected.add(group.id());
        }
      });

      var tokens = [].concat(_toConsumableArray(selected)).sort(function (a, b) {
        return a - b;
      });

      if (tokens.length) {
        var startToken = tokensById[tokens[0]];
        var endToken = tokensById[tokens[tokens.length - 1]];

        var isValid = _this3.isValidSelection(spans, tokensById, startToken.id, endToken.id);

        return {
          startToken: startToken,
          endToken: endToken,
          range: tokens,
          isValid: isValid
        };
      }

      return null;
    }, _this3.handleSelectSpanDown = function (event) {
      if (event.target.name() == 'token-text') return;
      var pt = (0, _util.getPointerPosition)(event.target.getStage());

      _this3.setState({
        x: pt.x,
        y: pt.y,
        drawing: {
          x: pt.x,
          y: pt.y,
          width: 0,
          height: 0
        }
      });
    }, _this3.handleSelectSpanMove = function (event) {
      var _this3$state10 = _this3.state,
          drawing = _this3$state10.drawing,
          x = _this3$state10.x,
          y = _this3$state10.y;

      if (drawing) {
        var pt = (0, _util.getPointerPosition)(event.target.getStage());
        var newDrawing = (0, _util.pointsToRect)([[x, y], [pt.x, pt.y]]);

        var selection = _this3.getTokenSelection(newDrawing);

        var drawingValid = selection ? selection.isValid : null;
        var drawingRange = selection ? selection.range : null;

        _this3.setState({
          drawing: newDrawing,
          drawingValid: drawingValid,
          drawingRange: drawingRange
        });
      }
    }, _this3.splitSpan = function (token) {
      var spans = _this3.state.spans;

      if (spans.length) {
        var newSpans = spans.filter(function (span) {
          return span.token_end !== token.id;
        });

        _this3.updateSpans(newSpans);
      }
    }, _this3.addSpan = function (startToken, endToken) {
      var _this3$state11 = _this3.state,
          spanLabel = _this3$state11.spanLabel,
          spans = _this3$state11.spans;
      var newSpan = {
        start: startToken.start,
        end: endToken.end,
        token_start: startToken.id,
        token_end: endToken.id,
        label: spanLabel
      };
      var newSpans = [].concat(_toConsumableArray(spans), [newSpan]).sort(function (a, b) {
        return a.start - b.start;
      });

      _this3.updateSpans(newSpans);

      _this3.setState({
        hover: null,
        selected: null
      });
    }, _this3.handleSelectSpanUp = function (event) {
      var drawing = _this3.state.drawing;

      var selection = _this3.getTokenSelection(drawing);

      if (selection) {
        var startToken = selection.startToken,
            endToken = selection.endToken,
            isValid = selection.isValid;

        if (isValid) {
          _this3.addSpan(startToken, endToken);
        }
      }

      if (drawing) {
        _this3.setState({
          drawing: null,
          drawingValid: null,
          drawingRange: null,
          selected: null,
          x: null,
          y: null
        });
      }
    }, _this3.handleWrap = function () {
      var _this3$state12 = _this3.state,
          wrap = _this3$state12.wrap,
          offset = _this3$state12.offset;
      if (!wrap && offset >= MAX_CANVAS_WIDTH) _this3.resetStage();

      _this3.setState({
        wrap: !wrap
      }, function () {
        return _this3.updateTokens(!wrap);
      });
    }, _this3.getCursor = function () {
      var _this3$state13 = _this3.state,
          hover = _this3$state13.hover,
          arcHover = _this3$state13.arcHover,
          mode = _this3$state13.mode,
          drawing = _this3$state13.drawing,
          selected = _this3$state13.selected;
      var isManual = _this3.props.isManual;

      if (selected !== null && hover !== null && hover !== selected && isManual && mode !== 'spans') {
        return 'alias';
      }

      if (mode === 'spans') return 'crosshair';
      if ((hover !== null || arcHover !== null) && isManual) return 'pointer';
    }, _this3.handleShortcuts = function (action) {
      // TODO: more shortcuts and tab actions?
      var _this3$state14 = _this3.state,
          modes = _this3$state14.modes,
          mode = _this3$state14.mode,
          selected = _this3$state14.selected;

      switch (action) {
        case 'rels':
          if (modes) _this3.setState({
            mode: 'rels'
          });
          break;

        case 'spans':
          if (modes) _this3.setState({
            mode: 'spans'
          });
          break;

        case 'delete':
          if (mode === 'spans' && selected !== null) {
            _this3.deleteSelected();
          }

          break;

        case 'reset':
          _this3.handleReset();

          break;

        case 'exit':
          _this3.setState({
            selected: null,
            drawing: null,
            drawingValid: null,
            drawingRange: null
          });

          break;
      }
    }, _temp2), _possibleConstructorReturn(_this3, _ret2);
  }

  _createClass(Relations, [{
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _props2 = this.props,
          isManual = _props2.isManual,
          spacing = _props2.spacing,
          arrowWidth = _props2.arrowWidth,
          tokenFontSize = _props2.tokenFontSize,
          labelFontSize = _props2.labelFontSize,
          labelHeight = _props2.labelHeight,
          config = _props2.config,
          nowrap = _props2.nowrap,
          classes = _props2.classes,
          theme = _props2.theme,
          translate = _props2.translate,
          ToolbarButton = _props2.ToolbarButton,
          ToolbarCheckbox = _props2.ToolbarCheckbox,
          children = _props2.children;
      var cardStyle = config.cardStyle,
          labelStyle = config.labelStyle,
          labelKeymap = config.labelKeymap,
          labels = config.labels,
          relationsSpanLabels = config.relationsSpanLabels,
          hideRelationArrow = config.hideRelationArrow;
      var _state = this.state,
          relations = _state.relations,
          origRelations = _state.origRelations,
          spans = _state.spans,
          origSpans = _state.origSpans,
          selected = _state.selected,
          rows = _state.rows,
          width = _state.width,
          height = _state.height,
          offset = _state.offset,
          showAll = _state.showAll,
          showLabels = _state.showLabels,
          label = _state.label,
          spanLabel = _state.spanLabel,
          wrap = _state.wrap,
          drawing = _state.drawing,
          drawingValid = _state.drawingValid,
          drawingRange = _state.drawingRange,
          mode = _state.mode,
          modes = _state.modes,
          visibleRelations = _state.visibleRelations,
          relColors = _state.relColors,
          hasSpans = _state.hasSpans;
      var LabelComponent = labelStyle == 'dropdown' ? _LabelDropdown2["default"] : _LabelList2["default"];
      var isSpans = mode === 'spans';
      var listeningArrow = isManual && (!isSpans || !!drawing);

      var handleStageEvent = function handleStageEvent(fn) {
        return isSpans ? function (e) {
          return animate(fn(e));
        } : null;
      };

      var drawingHandlers = {
        onMouseDown: handleStageEvent(this.handleSelectSpanDown),
        onMouseMove: handleStageEvent(this.handleSelectSpanMove),
        onMouseUp: handleStageEvent(this.handleSelectSpanUp),
        onTouchStart: handleStageEvent(this.handleSelectSpanDown),
        onTouchMove: handleStageEvent(this.handleSelectSpanMove),
        ontouchEnd: handleStageEvent(this.handleSelectSpanUp)
      };
      var tokenProps = {
        theme: theme,
        label: label,
        selected: selected,
        relColors: relColors,
        getColor: this.getColor,
        drawingRange: drawingRange,
        drawing: drawing,
        drawingValid: drawingValid,
        tokenFontSize: tokenFontSize,
        spacing: spacing,
        isManual: isManual,
        isSpans: isSpans,
        labelHeight: labelHeight,
        labelFontSize: labelFontSize,
        showLabels: showLabels,
        onHover: function onHover(hover) {
          _this5.setState({
            hover: hover
          });

          if (!showAll) _this5.updateVisibleRelations(relations, false);
        },
        drawingHandlers: drawingHandlers
      };
      var arrowProps = {
        theme: theme,
        hideRelationArrow: hideRelationArrow,
        arrowWidth: arrowWidth
      };
      var arrowLabelProps = {
        theme: theme,
        spacing: spacing,
        handleDelete: this.handleDelete,
        labelHeight: labelHeight,
        labelFontSize: labelFontSize,
        drawing: drawing,
        listening: listeningArrow,
        isSpans: isSpans,
        onHover: function onHover(arcHover) {
          return _this5.setState({
            arcHover: arcHover
          });
        }
      };

      var toolbar = _react2["default"].createElement(_util.ShortcutsWrapper, {
        ctx: this.context.shortcuts,
        className: classes.shortcuts,
        name: this.keymap,
        handler: this.handleShortcuts,
        targetNodeSelector: 'body',
        global: true
      }, _react2["default"].createElement(_Toolbar.Toolbar, null, _react2["default"].createElement('div', {
        className: classes.checkboxWrapper
      }, modes.map(function (m) {
        return _react2["default"].createElement(ToolbarButton, {
          key: m,
          id: m,
          active: mode == m,
          onClick: function onClick() {
            return _this5.setState({
              mode: m,
              selected: null
            });
          },
          title: translate('relations_' + m, m),
          keyName: (0, _util.getKeyName)(_this5.context, _this5.keymap, m)
        });
      }), _react2["default"].createElement('div', null, _react2["default"].createElement(ToolbarCheckbox, {
        checked: showAll,
        onChange: function onChange() {
          _this5.setState({
            showAll: !showAll
          });

          _this5.updateVisibleRelations(relations, !showAll);
        },
        label: translate('show_all_rels', 'All relations'),
        disabled: !relations.length
      }), _react2["default"].createElement(ToolbarCheckbox, {
        checked: showLabels,
        onChange: function onChange() {
          return _this5.setState({
            showLabels: !showLabels
          });
        },
        label: translate('show_all_labels', 'All labels'),
        disabled: !spans.length
      }), _react2["default"].createElement(ToolbarCheckbox, {
        checked: wrap,
        onChange: this.handleWrap,
        label: translate('wrap_lines', 'Wrap')
      }))), isManual && _react2["default"].createElement('div', null, hasSpans && _react2["default"].createElement(ToolbarButton, {
        id: 'delete',
        onClick: this.deleteSelected,
        disabled: !isSpans || selected === null,
        keyName: (0, _util.getKeyName)(this.context, this.keymap, 'delete'),
        title: translate('delete_span', 'Delete span')
      }), _react2["default"].createElement(ToolbarButton, {
        id: 'reset',
        onClick: this.handleReset,
        keyName: (0, _util.getKeyName)(this.context, this.keymap, 'reset'),
        title: translate('reset', 'Reset'),
        disabled: !relations.length && !origRelations.length && !origSpans.length && !spans.length
      }))));

      return _react2["default"].createElement(_react.Fragment, null, _react2["default"].createElement(_shared.Heading, {
        toolbar: toolbar,
        classes: {
          _root: classes.heading
        },
        hasLabels: true
      }, _react2["default"].createElement(LabelComponent, {
        labels: isSpans ? relationsSpanLabels : labels,
        selected: isSpans ? spanLabel : label,
        handleSelect: this.toggleElementSelect,
        keymap: labelKeymap
      })), _react2["default"].createElement(_shared.Content, {
        cardStyle: cardStyle,
        nowrap: nowrap
      }, _react2["default"].createElement('div', {
        className: classes.wrapper,
        ref: function ref(x) {
          _this5.content = x;
        }
      }, _react2["default"].createElement(_reactKonva.Stage, _extends({
        width: width,
        height: height,
        style: {
          cursor: this.getCursor()
        }
      }, drawingHandlers), _react2["default"].createElement(_reactKonva.Layer, {
        ref: function ref(x) {
          _this5.layers.tokens = x;
        }
      }, rows.map(function (rowTokens) {
        return rowTokens.map(function (token) {
          return _react2["default"].createElement(Token, _extends({
            key: token.id,
            token: token,
            isSelected: selected === token.id,
            handleTokenClick: _this5.handleTokenClick(token),
            handleTokenDblclick: _this5.handleTokenDblclick(token)
          }, tokenProps));
        });
      })), _react2["default"].createElement(_reactKonva.Layer, {
        ref: function ref(x) {
          _this5.layers.arrows = x;
        },
        listening: false,
        hitGraphEnabled: false
      }, visibleRelations.map(function (rel, i) {
        return _react2["default"].createElement(Arc, _extends({
          key: i,
          rel: rel,
          i: i
        }, arrowProps));
      })), _react2["default"].createElement(_reactKonva.Layer, {
        ref: function ref(x) {
          _this5.layers.arrowLabels = x;
        },
        listening: listeningArrow,
        hitGraphEnabled: listeningArrow
      }, visibleRelations.map(function (rel, i) {
        return _react2["default"].createElement(ArrowLabel, _extends({
          key: i,
          rel: rel,
          i: i
        }, arrowLabelProps));
      })), _react2["default"].createElement(_reactKonva.Layer, {
        ref: function ref(x) {
          _this5.layers.drawing = x;
        }
      }, isSpans && drawing && _react2["default"].createElement(_reactKonva.Rect, {
        x: drawing.x + (this.content && !wrap && offset >= MAX_CANVAS_WIDTH ? this.content.scrollLeft : 0),
        y: drawing.y,
        width: drawing.width,
        height: drawing.height,
        cornerRadius: 3,
        perfectDrawEnabled: false,
        listening: false,
        fill: drawingValid === true ? theme.accept : drawingValid === false ? theme.reject : theme.ignore,
        opacity: 0.2
      }))))), children);
    }
  }]);

  return Relations;
}(_react2["default"].Component), _class3.id = 'relations', _class3.defaultProps = {
  isManual: true,
  spacing: TOKEN_FONT_SIZE * 0.625,
  arrowWidth: 3,
  tokenHeight: TOKEN_FONT_SIZE * 2.25,
  tokenFontSize: TOKEN_FONT_SIZE,
  labelFontSize: TOKEN_FONT_SIZE * 0.75,
  labelHeight: TOKEN_FONT_SIZE * 1.05,
  arcHeight: TOKEN_FONT_SIZE * 1.5,
  ToolbarButton: _Toolbar.ToolbarButton,
  ToolbarCheckbox: _Toolbar.ToolbarCheckbox
}, _class3.contextTypes = {
  shortcuts: _propTypes2["default"].object
}, _temp3)) || _class2);
exports["default"] = Relations;